import { FC } from 'react';

import { Box, Header, Text } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import { primitive } from 'styles/constants/primitives';

import { IHeroSuperText, ISanityHeroTextProps } from './types';
import { getColorForSanityHeroTextColor } from './utils';

export const DoubleActionBtnWrapper = Box.withConfig({
  alignContent: 'flex-end',
  marginTop: {
    base: '-8',
    md: '12',
  },
});

export const WhiteBGWrapper = Box.withConfig({
  background: Styles.color.white,
  padding: '1',
  width: {
    base: 'full',
    md: 'unset',
  },
});

export const Icon = Picture.withConfig({
  width: '6',
  height: '5',
  borderRadius: 'unset',
});

export const LeftDesktopBtnWrapper = Box.withConfig({
  marginLeft: '5',
});

export const BottomHeroButtonWrapper = Box.withConfig({
  marginTop: '8',
  marginBottom: '4',
  justifyContent: 'center',
});

export const SanityDescription = Text.withConfig<ISanityHeroTextProps>(
  ({ $sanityTextColor, $defaultTextColor }) => ({
    color: getColorForSanityHeroTextColor($sanityTextColor, $defaultTextColor),
    fontSize: {
      base: 'md',
      md: '2xl',
    },
    textTransform: 'uppercase',
    textAlign: {
      base: 'center',
      md: 'left',
    },
    style: {
      textShadowColor: primitive.bk.$bbqBrown,
      textShadowOffset: {
        width: 0,
        height: 0.5,
      },
      textShadowRadius: 2,
    },
  })
);

export const HeroContainer: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <>{children}</>
);

export const HeroContent = Box.withConfig<{ $windowHeight: number }>(p => ({
  paddingY: {
    base: '4',
    md: '16',
  },
  paddingX: {
    base: 0,
    md: '12',
  },
  minHeight: {
    base: p.$windowHeight * 0.65,
    md: 'none',
  },
  justifyContent: {
    md: 'center',
  },
}));

export const HeroSuperText: React.FC<React.PropsWithChildren<IHeroSuperText>> = ({
  children,
  ...props
}) => {
  const SanityHeroSuperText = Header.withConfig<IHeroSuperText>(
    ({ $sanityTextColor, $defaultTextColor }) => ({
      color: getColorForSanityHeroTextColor($sanityTextColor, $defaultTextColor),
      textAlign: {
        base: 'center',
        md: 'left',
      },
      width: 'full',
      opacity: 0.9,
      style: {
        textShadowColor: primitive.bk.$bbqBrown,
        textShadowOffset: {
          width: 0,
          height: 0.5,
        },
        textShadowRadius: 2,
      },
      marginY: 0,
    })
  );

  return (
    <SanityHeroSuperText variant="headerOne" {...props}>
      {children}
    </SanityHeroSuperText>
  );
};

export const SanityHeroHeading = Header.withConfig<ISanityHeroTextProps>(
  ({ $sanityTextColor, $defaultTextColor }) => ({
    color: getColorForSanityHeroTextColor($sanityTextColor, $defaultTextColor),
    variant: 'headerOne',
    shadow: 'none',
    fontWeight: Styles.fontWeight.normal,
    fontSize: {
      base: '7xl',
      md: '9xl',
    },
    style: {
      textShadowColor: primitive.bk.$bbqBrown,
      textShadowOffset: {
        width: 0,
        height: 0.5,
      },
      textShadowRadius: 2,
    },
    margin: 0,
    marginBottom: {
      md: '10',
    },
    textAlign: {
      base: 'center',
      md: 'left',
    },
  })
);
